import $ from "./jquery.js";

/**
 * Trailing-edge debounce. Replaces the old $.fn.smartresize plugin — call it
 * directly on the handler you pass to addEventListener.
 */
export function debounce(fn, wait = 100) {
  let timeout;

  return function debounced(...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => fn.apply(this, args), wait);
  };
}

/** Scroll to `<a name="...">` or `#id`, allowing for a fixed header. */
export function scrollToAnchor(id, offset = 60) {
  const target = document.querySelector(`a[name="${id}"], #${CSS.escape(id)}`);

  if (!target) {
    return;
  }

  window.scrollTo({
    top: target.getBoundingClientRect().top + window.scrollY - offset,
    behavior: "smooth",
  });
}

export function backToTop() {
  window.scrollTo({ top: 0, behavior: "smooth" });
}

/**
 * Give every element in the set the height of the tallest one.
 * Prefer a flex or grid container where you can — this is for the cases
 * where the elements do not share a parent.
 */
export function equalHeights(selector) {
  const $elements = $(selector);

  if (!$elements.length) {
    return;
  }

  $elements.css("height", "");

  const tallest = Math.max(...$elements.map((_, el) => $(el).height()).get());

  $elements.height(tallest);
}

/** Pad elements from the top so their content sits on a shared baseline. */
export function baselineAlign(selector) {
  const $elements = $(selector);

  if (!$elements.length) {
    return;
  }

  $elements.css("padding-top", "");

  const tallest = Math.max(...$elements.map((_, el) => $(el).height()).get());

  $elements.each((_, el) => {
    $(el).css("padding-top", tallest - $(el).height());
  });
}

/** Vertically centre `content` within its closest `container`. */
export function alignContent(container, content) {
  $(content).each((_, el) => {
    const $el = $(el);
    const $parent = $el.closest(container);

    $el.css("padding-top", ($parent.outerHeight() - $el.outerHeight()) / 2);
  });
}
